var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskAnimals = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M13.47 14.23 8.955 9.716a13.3 13.3 0 0 1 5.642-6.613l.068 10.523zm9.21-2.504-1.517.704a2.25 2.25 0 0 0-3.957.731l-3.947 2.051L1.675 3.632c-1.31 4.967.14 10.223 3.707 13.762l-.007.002c-.671.957-1.853 1.68-3.581 1.683 2.267 2.377 6.245 2.158 8.807.854l11.61-6.674c.536-.309.74-.98.468-1.533"
})));
export default SvgTaskAnimals;